"use client"

import type { ComponentProps } from "react"
import { OnboardingStepActions } from "@/components/onboarding/onboarding-step-actions"
import { cn } from "@/lib/utils"

/** Extends to the card edges while keeping the buttons inside their owning form. */
export function WizardStepActions({ className, ...props }: ComponentProps<typeof OnboardingStepActions>) {
  return (
    <OnboardingStepActions
      className={cn("-mx-4 !-mb-4 mt-6 border-t bg-muted/20 p-4 sm:-mx-6 sm:!-mb-6 sm:p-6", className)}
      {...props}
    />
  )
}
